import React from 'react'
import Nav from '../nav/Nav'
import style from './dashboard.module.css'

const Dashboard = () => {
  return (
    <>
    <Nav/>
     <div>
      
      </div>
    </>
   
  )
}

export default Dashboard
